module.exports = __webpack_public_path__ + "static/media/react-logo.5ed88180.svg";